export const INSTAGRAM = {
    cerimonial: "https://www.instagram.com/lccerimonialoficial",
    astrolive: "https://www.instagram.com/astroliveshow",
};
